
import { defineComponent, ref, computed, getCurrentInstance } from 'vue';
import ActionSheet from 'vant/lib/action-sheet';

export default defineComponent({
  components: {
    vanActionSheet: ActionSheet,
  },
  setup(_, context) {
    const { proxy } = getCurrentInstance() as { proxy: any }
    const show = ref(true);

    const handleClose = () => {
      show.value = false;
      setTimeout(() => {
        context.emit('close', { button_type: 'close' });
      }, 500);
    };

    const handleConfirm = () => {
      show.value = false;
      context.emit('confirm');
    };

    const titleWords = computed(() => {
      return proxy.$root.$t('add_to_home_screen').replace('${0}', proxy.$appName)
    })
    const description = computed(() => {
      return proxy.$root.$t('a2hs_desc').replace('${0}', proxy.$appName)
    })


    return {
      show,
      titleWords,
      description,
      handleClose,
      handleConfirm,
    };
  },
});
